export const categories = [
  { slug: 'all', name: '全部漫画', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱言情', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情悬疑', icon: 'ri-movie-line' },
  { slug: 'thriller', name: '惊悚恐怖', icon: 'ri-ghost-line' },
  { slug: 'school', name: '校园青春', icon: 'ri-building-line' },
  { slug: 'historical', name: '古风历史', icon: 'ri-ancient-gate-line' },
  { slug: 'bl', name: 'BL耽美', icon: 'ri-star-line' },
];

export const comics = [
  {
    id: 1,
    title: '秘密花园',
    author: '金智慧',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20art%20featuring%20a%20romantic%20couple%20in%20a%20flower%20garden%20with%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20lines%2C%20soft%20lighting%2C%20warm%20tone%2C%20delicate%20details&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一个关于秘密与爱情的故事。在繁华都市的一角，隐藏着一座不为人知的秘密花园，这里见证了无数动人的爱情故事。女主角林小夏偶然闯入这片神秘之地，邂逅了守护花园的神秘男子，一段跨越时空的浪漫奇缘就此展开。',
    rating: 4.8,
    views: 1250000,
    status: '连载中',
    chapters: 86,
    updateDate: '2026-08-03',
    tags: ['恋爱', '都市', '奇幻'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '朴俊秀',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Korean%20manhwa%20cover%20featuring%20a%20mysterious%20detective%20in%20a%20rainy%20city%20alleyway%20at%20night%2C%20noir%20style%2C%20dramatic%20shadows%2C%20Korean%20webtoon%20art%2C%20cinematic%20lighting%2C%20dark%20blue%20and%20red%20accents&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '夜幕降临，罪恶开始滋生。刑警韩泰宇拥有特殊的能力——他能在梦中预见犯罪的发生。当城市中接连出现离奇案件，他必须在梦境与现实之间寻找真相，一场与时间的赛跑就此开始。',
    rating: 4.6,
    views: 980000,
    status: '连载中',
    chapters: 64,
    updateDate: '2026-08-02',
    tags: ['悬疑', '动作', '超能力'],
    featured: true,
    hot: false,
  },
  {
    id: 3,
    title: '甜蜜契约',
    author: '李多惠',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20and%20romantic%20Korean%20manhwa%20cover%20showing%20a%20young%20couple%20holding%20hands%20in%20a%20cafe%2C%20warm%20lighting%2C%20Korean%20webtoon%20style%2C%20soft%20pink%20and%20cream%20tones%2C%20cozy%20atmosphere%2C%20beautiful%20character%20design&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '为了拯救父亲的公司，尹素熙不得不接受一份特殊的契约婚姻。对方是冷傲的集团继承人车敏俊。原以为只是一场交易，却在朝夕相处中，两人的心渐渐靠近。但隐藏在契约背后的秘密，正慢慢浮出水面。',
    rating: 4.9,
    views: 2100000,
    status: '已完结',
    chapters: 120,
    updateDate: '2026-07-15',
    tags: ['恋爱', '契约婚姻', '总裁'],
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '异世界食堂',
    author: '郑宇成',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20manhwa%20cover%20featuring%20a%20magical%20restaurant%20with%20floating%20food%20and%20fantasy%20creatures%2C%20warm%20golden%20and%20green%20tones%2C%20Korean%20webtoon%20illustration%2C%20detailed%20food%20art%2C%20enchanted%20atmosphere&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '普通厨师金东旭一觉醒来，发现自己穿越到了剑与魔法的异世界。凭借着精湛的厨艺，他在异世界开了一家小小的食堂。没想到，这里的美食竟然吸引了各路英雄豪杰，连魔王都成为了常客！',
    rating: 4.7,
    views: 1560000,
    status: '连载中',
    chapters: 92,
    updateDate: '2026-08-04',
    tags: ['奇幻', '美食', '穿越'],
    featured: true,
    hot: true,
  },
  {
    id: 5,
    title: '搞笑一家人',
    author: '崔美英',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20lively%20Korean%20manhwa%20cover%20showing%20a%20chaotic%20family%20gathering%20with%20exaggerated%20expressions%2C%20bright%20colors%2C%20cartoonish%20Korean%20webtoon%20style%2C%20yellow%20and%20orange%20warm%20tones%2C%20humorous%20scene&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '四世同堂的李家每天上演着各种啼笑皆非的故事。从82岁的太奶奶到5岁的小孙女，每个家庭成员都有自己独特的个性。吵吵闹闹中，却是最温暖的日常。',
    rating: 4.5,
    views: 890000,
    status: '连载中',
    chapters: 156,
    updateDate: '2026-08-03',
    tags: ['搞笑', '日常', '家庭'],
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '第七夜的秘密',
    author: '尹智恩',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20elegant%20Korean%20manhwa%20cover%20featuring%20a%20woman%20in%20a%20grand%20mansion%20hallway%20with%20candlelight%2C%20dark%20academia%20vibe%2C%20Korean%20webtoon%20style%2C%20deep%20brown%20and%20gold%20tones%2C%20vintage%20atmosphere&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '在一座古老的庄园中，每隔七天就会发生一起离奇事件。新来的家庭教师沈素英开始注意到这些诡异事件背后的规律。随着调查深入，她发现这座庄园和它的主人，都隐藏着不为人知的秘密。',
    rating: 4.8,
    views: 1130000,
    status: '连载中',
    chapters: 48,
    updateDate: '2026-08-01',
    tags: ['悬疑', '推理', '古堡'],
    featured: true,
    hot: false,
  },
  {
    id: 7,
    title: '校园方程式',
    author: '安世勋',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20youthful%20Korean%20manhwa%20cover%20showing%20students%20in%20school%20uniforms%20under%20cherry%20blossom%20trees%2C%20bright%20spring%20colors%2C%20Korean%20webtoon%20style%2C%20fresh%20and%20energetic%20vibe%2C%20pastel%20pink%20and%20green%20tones&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '天才赛车手韩智浩因伤退出职业赛场，转入普通高中。在这里他遇到了对赛车充满热情的同学金美娜。两人组建校园赛车队，从零开始挑战全国高中生方程式大赛。',
    rating: 4.4,
    views: 670000,
    status: '连载中',
    chapters: 55,
    updateDate: '2026-08-02',
    tags: ['校园', '赛车', '青春'],
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '千年狐妖传',
    author: '张瑞元',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20featuring%20a%20nine-tailed%20fox%20spirit%20in%20traditional%20hanbok%2C%20ancient%20Korean%20palace%20background%2C%20mystical%20atmosphere%2C%20Korean%20webtoon%20style%2C%20red%20and%20gold%20traditional%20colors%2C%20elegant%20ink%20wash%20painting%20feel&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '修行千年的九尾狐白灵化为人形，来到人间寻找失散的恋人转世。从高丽王朝到现代首尔，她穿越千年时光，见证历史变迁，只为兑现当年的承诺。',
    rating: 4.7,
    views: 1420000,
    status: '连载中',
    chapters: 78,
    updateDate: '2026-08-04',
    tags: ['古风', '奇幻', '爱情'],
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '深渊之眼',
    author: '权志龙',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20terrifying%20Korean%20manhwa%20cover%20with%20a%20glowing%20eye%20in%20darkness%2C%20horror%20theme%2C%20Korean%20webtoon%20style%2C%20deep%20red%20and%20black%20colors%2C%20haunting%20atmosphere%2C%20psychological%20horror%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '精神科医生崔敏俊接手了一位特殊病人——声称能看到「深渊」的少女。起初他以为只是妄想症，直到他自己也开始看到那些无法解释的景象。深渊之中，究竟隐藏着什么？',
    rating: 4.6,
    views: 780000,
    status: '连载中',
    chapters: 42,
    updateDate: '2026-07-30',
    tags: ['惊悚', '心理', '超自然'],
    featured: false,
    hot: false,
  },
  {
    id: 10,
    title: '星月童话',
    author: '宋慧乔',
    category: 'bl',
    cover: 'https://readdy.ai/api/search-image?query=A%20tender%20and%20beautiful%20Korean%20BL%20manhwa%20cover%20showing%20two%20young%20men%20standing%20under%20a%20starry%20night%20sky%2C%20romantic%20and%20dreamy%2C%20Korean%20webtoon%20style%2C%20soft%20blue%20and%20silver%20tones%2C%20gentle%20atmosphere&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '天文学家尹星辰在观测星空时，意外发现了来自遥远星系的信号。与此同时，神秘的转学生李银河出现在他的生活中。星空下的邂逅，科学与爱的交汇，一段跨越星际的浪漫童话。',
    rating: 4.8,
    views: 1680000,
    status: '已完结',
    chapters: 95,
    updateDate: '2026-06-20',
    tags: ['BL', '科幻', '浪漫'],
    featured: true,
    hot: true,
  },
  {
    id: 11,
    title: '武林至尊',
    author: '刘承俊',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20warrior%20with%20glowing%20fist%20in%20a%20traditional%20oriental%20setting%2C%20dynamic%20action%20pose%2C%20Korean%20webtoon%20style%2C%20golden%20and%20crimson%20tones%2C%20epic%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '平凡少年江不凡在一次意外中获得神秘武功秘籍，从此踏上修炼之路。江湖险恶，强者为尊。他能否在这弱肉强食的武林中，成为真正的至尊？',
    rating: 4.5,
    views: 1050000,
    status: '连载中',
    chapters: 110,
    updateDate: '2026-08-03',
    tags: ['武侠', '热血', '修炼'],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: '放学后的图书馆',
    author: '金敏雅',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20nostalgic%20Korean%20manhwa%20cover%20showing%20two%20students%20in%20a%20sunlit%20library%2C%20books%20surrounding%20them%2C%20Korean%20webtoon%20style%2C%20soft%20afternoon%20light%2C%20brown%20and%20cream%20tones%2C%20peaceful%20mood&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '每天放学后，安静的图书馆里总有两个人的身影。学霸班长和爱看漫画的差生，因为一本被遗忘的书而产生了交集。在这个充满书香的地方，青春的故事悄然绽放。',
    rating: 4.3,
    views: 560000,
    status: '已完结',
    chapters: 60,
    updateDate: '2026-05-10',
    tags: ['校园', '青春', '治愈'],
    featured: false,
    hot: false,
  },
];